export default "__VITE_ASSET__CeoMPYdb__"